import { VueRenderer } from '@tiptap/vue-2'
import tippy from 'tippy.js'
import MentionList from '../components/MentionList.vue'
import commonsApi from '@/api/commons'

export default {
  items: async ({ query }) => {
    // TODO. esto debe ser una funcion suggester de elastic
    const users = await commonsApi.axiosGetWrapper('/users/mentions', {
      fullname: query
    })
    return users.data.items.slice(0, 10)
  },
  render: () => {
    let component
    let popup
    return {
      onStart: props => {
        component = new VueRenderer(MentionList, {
          // using vue 2:
          parent: this,
          propsData: props
          // props,
          // editor: props.editor,
        })
        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start'
        })
      },
      onUpdate (props) {
        component.updateProps(props)
        popup[0].setProps({
          getReferenceClientRect: props.clientRect
        })
      },
      onKeyDown (props) {
        if (props.event.key === 'Escape') {
          popup[0].hide()
          return true
        }
        return component.ref?.onKeyDown(props)
      },
      onExit () {
        popup[0].destroy()
        component.destroy()
      }
    }
  }
}
